
document.addEventListener('DOMContentLoaded', function () {
  const swiperContainer = document.querySelector('.swiper-container');
  const blocks = document.querySelectorAll('.swiper-slide');


    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop:true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
        990: {
          slidesPerView: 4,
          spaceBetween:0,
        },
      },
    });
});